import * as React from "react"
import { SVGProps } from "react"

const RussiaPoints = (props: SVGProps<SVGSVGElement>) => (
	<svg
		{...props}
		width="301"
		height="200"
		viewBox="0 0 301 200"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<circle
			cx="150.5"
			cy="100"
			r="84"
			fill="white"
			stroke="#2A2D33"
			strokeWidth="2"
		/>
		<path
			d="M49.1387 116.635L57.1437 113.152C57.4144 113.035 57.7234 113.043 57.9878 113.174L69.1682 118.733C69.5081 118.902 69.723 119.249 69.723 119.628V122.55C69.723 122.896 69.9024 123.218 70.197 123.4L81.8269 130.593C82.2946 130.882 82.9081 130.739 83.2002 130.273L88.2402 122.233C88.4604 121.882 88.8747 121.703 89.2815 121.783L105.243 124.94C105.502 124.991 105.729 125.142 105.877 125.36L111.889 134.235C112.075 134.509 112.385 134.674 112.717 134.674H117.409C117.816 134.674 118.182 134.92 118.335 135.297L122.986 146.711C123.14 147.088 123.506 147.334 123.912 147.334H129.8C130.127 147.334 130.433 147.493 130.62 147.761L138.617 159.195C138.929 159.642 139.542 159.756 139.995 159.451L150.244 152.549C150.567 152.332 150.987 152.322 151.32 152.523L157.36 156.175C157.516 156.269 157.695 156.319 157.878 156.319H164.995C165.548 156.319 165.995 155.871 165.995 155.319V153.218C165.995 152.687 166.41 152.249 166.939 152.219L185.55 151.175C185.737 151.164 185.922 151.206 186.086 151.296L192.406 154.749C192.734 154.929 193.136 154.909 193.446 154.699L204.374 147.289C204.54 147.176 204.736 147.116 204.936 147.116H212.875C213.379 147.116 213.804 146.742 213.867 146.242L215.114 136.382C215.141 136.168 215.236 135.969 215.385 135.814L222.944 127.956C223.29 127.597 223.848 127.547 224.251 127.84L234.981 135.607C235.345 135.871 235.84 135.859 236.191 135.579L238.389 133.827C238.715 133.566 239.17 133.536 239.528 133.752L245.604 137.409C246.034 137.668 246.589 137.568 246.902 137.175L251.069 131.936C251.519 131.37 252.403 131.454 252.738 132.095L256.624 139.522C256.746 139.753 256.771 140.023 256.696 140.273L254.2 148.595C254.007 149.236 254.488 149.882 255.157 149.882H259.943C260.243 149.882 260.528 149.747 260.718 149.514L265.136 144.095C265.281 143.916 265.361 143.693 265.361 143.463V118.959C265.361 118.668 265.234 118.391 265.013 118.201L252.307 107.254C252.125 107.098 251.894 107.012 251.654 107.012H242.071C241.519 107.012 241.071 106.564 241.071 106.012V88.7223C241.071 88.5098 241.139 88.3029 241.265 88.1315L251.724 73.8506C251.913 73.5919 251.967 73.2579 251.869 72.9527L248.529 62.6019C248.321 61.9562 248.802 61.2948 249.481 61.2948H250.908C251.571 61.2948 252.051 60.6602 251.87 60.0217L251.387 58.3213C251.206 57.6829 251.685 57.0482 252.349 57.0482H254.078C254.516 57.0482 254.902 57.3324 255.033 57.7499L259.829 73.0939C259.899 73.3167 260.044 73.5081 260.24 73.635L276.456 84.1359C277.122 84.5668 278 84.0892 278 83.2966V76.3192C278 76.0064 277.854 75.7117 277.604 75.5226L274.064 72.8362C273.941 72.7425 273.841 72.6212 273.772 72.4821L269.482 63.7854C269.399 63.6184 269.272 63.4777 269.114 63.3792L259.582 57.4372C259.21 57.2058 259.033 56.7599 259.143 56.3366L261.805 46.1166C261.858 45.9118 261.845 45.6953 261.767 45.4984L255.751 30.2083C255.6 29.8259 255.231 29.5745 254.82 29.5745H251.308C251.011 29.5745 250.73 29.4428 250.54 29.2149L247.39 25.4368C247.122 25.1156 247.083 24.6616 247.291 24.2988L250.98 17.8706C251.403 17.1321 250.769 16.2356 249.932 16.3894L241.743 17.8923C241.515 17.9343 241.308 18.0548 241.158 18.233L228.738 33.0297C228.619 33.1713 228.542 33.343 228.515 33.5259L226.776 45.2503C226.726 45.5929 226.501 45.8849 226.183 46.022L203.525 55.788C203.014 56.0081 202.781 56.6025 203.006 57.111L204.207 59.8243C204.391 60.2413 204.27 60.7303 203.913 61.0132L198.088 65.6206C197.818 65.8342 197.457 65.8939 197.133 65.7786L190.991 63.5963C190.755 63.5122 190.495 63.5203 190.264 63.6189L171.673 71.5558C170.789 71.933 169.934 70.9688 170.414 70.1366L174.724 62.6632C174.971 62.2339 174.867 61.688 174.479 61.3801L170.714 58.3948C170.412 58.1557 170 58.1108 169.654 58.2793L136.55 74.4055C135.985 74.6806 135.31 74.3731 135.147 73.7665L133.658 68.2368C133.477 67.5652 132.683 67.2788 132.115 67.6803L121.123 75.4514C120.783 75.6921 120.329 75.6963 119.984 75.462L107.568 67.0257C107.402 66.9131 107.206 66.8529 107.006 66.8529H82.4661C81.7595 66.8529 81.2757 66.14 81.5368 65.4834L84.5873 57.8116C84.9615 56.8705 86.3369 57.0181 86.503 58.0171L87.0591 61.362C87.1393 61.8443 87.5566 62.198 88.0456 62.198H93.0459C93.5982 62.198 94.0459 61.7502 94.0459 61.198V47.6459C94.0459 47.0936 93.5982 46.6459 93.0459 46.6459H89.1598C88.9291 46.6459 88.7055 46.7257 88.5268 46.8718L72.4186 60.0425C72.2214 60.2038 71.97 60.2837 71.7159 60.2659L61.8197 59.574C61.6235 59.5603 61.4276 59.6047 61.2566 59.7017L49.1552 66.5655C48.8421 66.7431 48.6486 67.0753 48.6486 67.4353V71.7338C48.6486 71.9314 48.5901 72.1245 48.4804 72.2888L39.2679 86.0977C39.1275 86.3081 39.0721 86.5639 39.1128 86.8135L41.458 101.21C41.5463 101.752 41.1812 102.263 40.6402 102.356L29.0966 104.337C28.8249 104.384 28.5845 104.541 28.4322 104.77L23.2952 112.521C23.1107 112.8 23.0774 113.152 23.2062 113.46L32.955 136.764C33.2156 137.387 34.0062 137.578 34.5224 137.142L46.5889 126.961C46.7668 126.811 46.8868 126.604 46.9281 126.375L48.5536 117.374C48.6129 117.046 48.8324 116.768 49.1387 116.635Z"
			fill="white"
			stroke="#2A2D33"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M179.229 68.3944L179.711 76.7196C179.72 76.8677 179.695 77.0157 179.64 77.1531L173.549 92.1784C173.476 92.3576 173.457 92.5539 173.493 92.7437L176.42 107.904C176.46 108.111 176.433 108.326 176.344 108.517L170.858 120.239C170.771 120.425 170.628 120.58 170.449 120.682L161.631 125.734C161.32 125.912 161.128 126.243 161.128 126.601V131.399C161.128 131.605 161.065 131.805 160.947 131.973L150.838 146.391C150.5 146.873 149.821 146.96 149.372 146.58L143.338 141.466C143.094 141.259 142.963 140.948 142.987 140.628L144.517 120.186C144.539 119.898 144.435 119.615 144.232 119.409L137.773 112.866C137.474 112.562 137.4 112.102 137.589 111.72L143.125 100.527C143.234 100.307 143.258 100.056 143.193 99.8198L140.087 88.4464C140.012 88.1712 140.058 87.877 140.213 87.6379L142.267 84.479C142.351 84.3495 142.404 84.2023 142.422 84.0489L143.167 77.6063"
			stroke="#2A2D33"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M137.233 112.324L125.688 109.494C125.346 109.41 124.985 109.513 124.738 109.763L119.938 114.631C119.551 115.022 118.921 115.028 118.527 114.644L111.836 108.114C111.619 107.901 111.316 107.8 111.014 107.837L104.319 108.675C103.722 108.749 103.195 108.284 103.195 107.682V98.4823C103.195 98.2913 103.14 98.1043 103.037 97.9435L99.8809 93.0091C99.6507 92.6493 99.6745 92.1829 99.9402 91.8484L106.241 83.9151C106.373 83.7494 106.553 83.6297 106.757 83.5732L111.492 82.2625M111.492 82.2625L110.186 89.3961C110.074 90.0103 110.545 90.5761 111.17 90.5761H118.17C118.531 90.5761 118.863 90.77 119.041 91.0837L123.968 99.7923C124.077 99.9859 124.248 100.137 124.453 100.223L139.933 106.675M111.492 82.2625L122.382 74.5635"
			stroke="#2A2D33"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M99.5915 92.3981L88.1396 88.2494C87.4417 87.9965 86.7212 88.5655 86.8055 89.303L87.0789 91.6976C87.107 91.9438 87.0427 92.1917 86.8984 92.3932L80.6012 101.187C80.3554 101.531 80.3517 101.991 80.592 102.338L84.2632 107.644C84.5789 108.1 85.2058 108.212 85.6599 107.893L88.7124 105.752M88.7124 105.752L92.2013 103.303C92.4466 103.131 92.6018 102.858 92.6241 102.559L92.8816 99.1074C92.9002 98.8591 93.0106 98.6267 93.1915 98.4555L96.2509 95.5598M88.7124 105.752L101.007 111.71C101.704 112.048 101.769 113.017 101.122 113.444L99.6963 114.386C99.2321 114.693 99.1075 115.32 99.4191 115.781L105.746 125.142"
			stroke="#2A2D33"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M74.8645 103.297L74.2482 94.9081C74.2218 94.5475 74.0027 94.2294 73.6754 94.0759L70.2347 92.4629M70.2347 92.4629L66.4052 96.1191C66.0571 96.4514 65.5217 96.4887 65.1309 96.2077L58.9506 91.7639M70.2347 92.4629L74.3069 88.6454C74.6361 88.3369 74.7179 87.8462 74.5066 87.4476L70.8154 80.4835C70.7376 80.3367 70.6245 80.2116 70.4862 80.1195L63.2611 75.3072M58.9506 91.7639L56.671 93.816C56.2126 94.2287 56.2335 94.954 56.7149 95.3396L73.0302 108.409C73.2671 108.599 73.405 108.886 73.405 109.19V118.086C73.405 118.476 73.6317 118.831 73.9859 118.994L77.2435 120.498C77.6009 120.663 78.0218 120.603 78.3188 120.344L86.8325 112.942C87.2167 112.608 87.2886 112.038 86.9994 111.619L80.1938 101.758M58.9506 91.7639L56.9096 83.3233M63.2611 75.3072L56.9096 83.3233M63.2611 75.3072L62.125 70.0483M56.9096 83.3233L48.6992 72.1416M62.125 70.0483L72.3493 68.976M62.125 70.0483L55.6113 63.0005"
			stroke="#2A2D33"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M83.5753 96.9241L79.9027 80.6458C79.8562 80.4397 79.7456 80.2535 79.5867 80.1142L73.1645 74.4802C72.9756 74.3145 72.856 74.0837 72.8295 73.8338L72.3336 69.1539C72.3087 68.9183 72.3682 68.6815 72.5016 68.4856L75.749 63.7178M57.6509 112.91L71.281 107.033M112.163 134.671H125.264C125.497 134.671 125.723 134.752 125.902 134.901L128.766 137.273C129.022 137.485 129.366 137.556 129.685 137.462L135.776 135.678C136.095 135.584 136.439 135.655 136.694 135.866L142.593 140.738C142.847 140.948 142.981 141.27 142.952 141.598L142.243 149.543"
			stroke="#2A2D33"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M156.236 138.855L163.495 142.836C163.851 143.032 164.29 142.992 164.606 142.736L165.767 141.794C166.097 141.526 166.561 141.497 166.922 141.72L176.157 147.427C176.565 147.679 177.094 147.606 177.418 147.254L183.011 141.181C183.181 140.996 183.275 140.754 183.275 140.503V130.146C183.275 129.729 183.535 129.355 183.926 129.209L199.804 123.296M206.114 126.301L197.6 112.923C197.315 112.475 196.731 112.328 196.268 112.587L184.914 118.949C184.215 119.341 183.363 118.794 183.428 117.996L183.825 113.14C183.838 112.984 183.813 112.826 183.754 112.681L180.377 104.413"
			stroke="#2A2D33"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M185.859 151.175L196.375 140.897C196.669 140.61 196.757 140.172 196.598 139.794L195.85 138.019C195.703 137.672 195.765 137.271 196.01 136.984L199.884 132.425C200.272 131.968 200.173 131.273 199.672 130.943L198.53 130.19C198.163 129.948 197.997 129.495 198.121 129.074L199.814 123.302L200.654 120.756C200.918 119.955 201.996 119.821 202.448 120.534L205.825 125.856C206.008 126.145 206.327 126.32 206.669 126.32H209.325C209.693 126.32 210.031 126.522 210.206 126.846L212.537 131.182"
			stroke="#2A2D33"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M204.011 122.094H218.31C218.434 122.094 218.558 122.071 218.674 122.026L226.619 118.919M226.619 118.919L224.44 106.424C224.381 106.085 224.501 105.739 224.756 105.509L231.106 99.7956C231.383 99.5467 231.499 99.1648 231.406 98.8043L229.136 89.9355C229.001 89.4074 229.314 88.8684 229.839 88.7235L234.78 87.361C235.274 87.2249 235.585 86.7377 235.501 86.2326L233.772 75.8602C233.726 75.5861 233.797 75.3054 233.966 75.0854L237.485 70.5186C237.714 70.2215 237.757 69.8213 237.598 69.482L235.42 64.8613C235.279 64.5614 235.296 64.211 235.464 63.9257L238.313 59.1143M226.619 118.919L227.919 118.251C228.633 117.884 229.467 118.467 229.368 119.264L229.056 121.781C228.999 122.241 229.266 122.68 229.7 122.841L232.146 123.754C232.542 123.901 232.988 123.784 233.261 123.46L239.031 116.604C239.74 115.763 241.089 116.515 240.747 117.56L236.873 129.376M238.313 59.1143L234.204 54.9369C233.903 54.631 233.831 54.1673 234.024 53.7844L235.208 51.4431C235.453 50.9582 235.266 50.3663 234.787 50.11L226.705 45.7886M238.313 59.1143L252.773 50.4345C253.213 50.17 253.783 50.2825 254.09 50.6949L255.876 53.0958"
			stroke="#2A2D33"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M42.2315 130.435L38.3055 117.202M38.3055 117.202L35.3071 107.207M38.3055 117.202L42.2092 114.622C42.5099 114.424 42.6804 114.078 42.6555 113.719L42.2696 108.139C42.2459 107.796 42.3999 107.465 42.6775 107.262L49.0994 102.574C49.5528 102.243 50.1898 102.35 50.5102 102.811L53.7479 107.469"
			stroke="#2A2D33"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M45.6914 86.6162L55.8123 94.6177"
			stroke="#2A2D33"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<rect
			x="184.744"
			y="13.0046"
			width="20.273"
			height="16.9399"
			transform="rotate(27.064 184.744 13.0046)"
			fill="white"
		/>
		<path
			d="M205.394 29.0155L200.585 26.5585L195.089 37.3142L204.669 42.2089L207.968 35.7513L205.394 29.0155Z"
			fill="white"
		/>
		<path
			d="M189.328 34.3698L195.089 37.3135L202.797 22.2286L184.744 13.0046L177.036 28.0895L180.471 29.8445"
			stroke="#2A2D33"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M203.149 41.4321L204.669 42.2087L207.97 35.7477L205.375 29.0055L200.585 26.5582L195.089 37.3141L196.609 38.0907"
			stroke="#2A2D33"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<circle
			cx="183.338"
			cy="31.3088"
			r="3.05997"
			transform="rotate(27.064 183.338 31.3088)"
			fill="white"
			stroke="#2A2D33"
			strokeWidth="2"
		/>
		<circle
			cx="199.88"
			cy="39.7613"
			r="3.05997"
			transform="rotate(27.064 199.88 39.7613)"
			fill="white"
			stroke="#2A2D33"
			strokeWidth="2"
		/>
		<rect
			x="116.242"
			y="187.997"
			width="20.273"
			height="16.9399"
			transform="rotate(-152.936 116.242 187.997)"
			fill="white"
		/>
		<path
			d="M95.5923 171.986L100.401 174.443L105.897 163.688L96.3168 158.793L93.0174 165.251L95.5923 171.986Z"
			fill="white"
		/>
		<path
			d="M111.658 166.632L105.896 163.688L98.189 178.773L116.242 187.997L123.95 172.912L120.515 171.157"
			stroke="#2A2D33"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M97.8367 159.57L96.3167 158.793L93.0155 165.254L95.611 171.996L100.401 174.444L105.896 163.688L104.376 162.911"
			stroke="#2A2D33"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<circle
			cx="117.648"
			cy="169.693"
			r="3.05997"
			transform="rotate(-152.936 117.648 169.693)"
			fill="white"
			stroke="#2A2D33"
			strokeWidth="2"
		/>
		<circle
			cx="101.106"
			cy="161.241"
			r="3.05997"
			transform="rotate(-152.936 101.106 161.241)"
			fill="white"
			stroke="#2A2D33"
			strokeWidth="2"
		/>
	</svg>
)

export default RussiaPoints
